import type { WorkspaceUser } from "@/types/domain"

export const demoWorkspaceUsers: WorkspaceUser[] = [
  {
    id: "demo-admin",
    name: "Marina Rocha",
    email: "marina@barca.cc",
    role: "ADMIN",
    functions: ["LEADERSHIP", "EDITOR_IN_CHIEF"],
    imprintIds: ["imprint-filosofia", "imprint-literatura"],
    createdAt: "2026-05-12T13:00:00.000Z",
    updatedAt: "2026-05-12T13:00:00.000Z",
    lastSignInAt: "2026-08-27T17:35:00.000Z",
  },
  {
    id: "demo-ops",
    name: "Caio Nunes",
    email: "caio@barca.cc",
    role: "OPS",
    functions: ["TEXT_REVIEWER", "DESIGNER"],
    imprintIds: ["imprint-filosofia", "imprint-ciencias"],
    createdAt: "2026-05-18T14:00:00.000Z",
    updatedAt: "2026-07-02T16:20:00.000Z",
    lastSignInAt: "2026-08-26T12:15:00.000Z",
  },
  {
    id: "demo-viewer",
    name: "Lia Martins",
    email: "lia@barca.cc",
    role: "VIEWER",
    functions: ["PROOFREADER"],
    imprintIds: ["imprint-literatura"],
    createdAt: "2026-06-03T10:30:00.000Z",
    updatedAt: "2026-06-03T10:30:00.000Z",
  },
]
